import { validatePhone, validateIdNo, validateEMail, validateName } from "common/js/utils/validator";

//基金管理机构 新建 step1
export const newStep1 = [
  {
    label: "企业名称(全称)",
    formtype: "",
    field: "institutionName",
    // disabled: true,
    require: true,
    rules: [{ required: true, message: "请输入注册资本", trigger: "blur" }]
  },
  {
    label: "注册资本（万元）",
    formtype: "",
    field: "capitalRegisted",
    // disabled: true,
    require: true,
    rules: [
      { required: false, message: "请输入注册资本", trigger: "blur" },
      { max: 16, message: "不能超过16位", trigger: "blur" }
    ]
  },
  {
    label: "统一社会信用代码（组织机构代码）",
    formtype: "",
    field: "associationNo",
    rules: [
      { required: false, message: "请输入注册资本", trigger: "blur" },
      { max: 18, message: "请输入正确的统一社会信用代码（组织机构代码）", trigger: "blur" }
    ],
    // disabled: true,
    require: true
  },
  {
    label: "实收资本（万元）",
    formtype: "",
    field: "capitalPaid",
    // disabled: true,
    require: true,
    rules: [
      { required: false, message: "请输入注册资本", trigger: "blur" },
      { max: 16, message: "不能超过16位", trigger: "blur" }
    ]
  },
  // ,{
  //     label: "成立日期",
  //     formtype: "",
  //     field: "createdTime",
  //     disabled: true,
  //
  // }
  {
    label: "管理人类型",
    formtype: "select",
    options: [
      {
        label: "股权、创业类",
        value: "股权、创业类"
      },
      {
        label: "证券类",
        value: "证券类"
      },
      {
        label: "其他",
        value: "其他"
      }
    ],
    field: "fundType",
    require: true
  },
  {
    label: "管理基金数量",
    formtype: "",
    field: "fundMgrScale",
    require: false
  },
  {
    label: "是否需要中国证券投资基金业协会登记/备案",
    formtype: "select",
    options: [
      {
        label: "是",
        value: "1"
      },
      {
        label: "否",
        value: "0"
      }
    ],
    field: "associationRegiste",
    require: false
  },
  {
    label: "是否完成中国证券投资基金业协会登记/备案",
    formtype: "select",
    options: [
      {
        label: "是",
        value: "1"
      },
      {
        label: "否",
        value: "0"
      }
    ],
    field: "associationRegisteFinished",
    require: false
  },
  {
    label: "管理基金认缴出资总额(万元)",
    formtype: "",
    field: "mgrFundCapitalAdmit",
    require: false,
    rules: [
      { required: false, message: "请输入注册资本", trigger: "blur" },
      { max: 16, message: "不能超过16位", trigger: "blur" }
    ]
  },
  // , {
  //     label: "是否完成中国证券投资基金业协会登记/备案",
  //     formtype: "select",
  //     options: [{
  //             label: "是",
  //             value: 1
  //         },
  //         {
  //             label: "否",
  //             value: 0
  //         }
  //     ],
  //     field: "associationRegisteFinished",
  //
  // }
  {
    label: "管理基金实缴出资总额(万元)",
    formtype: "",
    field: "mgrFundCapitalPaid",
    require: false,
    rules: [
      { required: false, message: "请输入注册资本", trigger: "blur" },
      { max: 16, message: "不能超过16位", trigger: "blur" }
    ]
  },
  {
    label: "中基协登记时间",
    formtype: "date",
    field: "registeTime",
    require: false
  },
  {
    label: "拟投行业",
    formtype: "select",
    selectType: true,
    options: [
      {
        label: "高端智能制造",
        value: "高端智能制造"
      },
      {
        label: "移动互联网",
        value: "移动互联网"
      },
      {
        label: "新材料",
        value: "新材料"
      },
      {
        label: "生物医药和健康",
        value: "生物医药和健康"
      },
      {
        label: "文化创新",
        value: "文化创新"
      },
      {
        label: "新能源和环保",
        value: "新能源和环保"
      },
      {
        label: "军民融合",
        value: "军民融合"
      },
      {
        label: "现代服务",
        value: "现代服务"
      },
      {
        label: "食品和家电",
        value: "食品和家电"
      },
      {
        label: "其他",
        value: "其他"
      }
    ],
    field: "preIndustry",
    require: false
  },
  {
    label: "主发起人省份",
    formtype: "select",
    options: [],
    field: "initiatorDistrict",
    require: false
  },
  {
    label: "职工人数",
    formtype: "",
    field: "staffCount",
    require: false
  },
  {
    label: "是否工位注册",
    formtype: "select",
    options: [
      {
        label: "是",
        value: "1"
      },
      {
        label: "否",
        value: "0"
      }
    ],
    field: "clusterRegiste",
    require: false
  },

  // {
  //     label: '工位注册托管期限',
  //     formtype: "date",
  //     field: "registeExpireDate",
  //
  // }
  //     ,

  {
    label: "从业人员数",
    formtype: "",
    field: "employeeCount",
    require: false
  },
  {
    label: "注册地址",
    formtype: "",
    field: "registeAddress",
    require: false,
    rules: [{ max: 255, message: "不能超过255位", trigger: "blur" }]
  },
  {
    label: "机构来源",
    formtype: "select",
    options: [
      {
        label: "已入驻客户新设机构",
        value: "已入驻客户新设机构"
      },
      {
        label: "慕名而来",
        value: "慕名而来"
      },

      {
        label: "他人推荐",
        value: "他人推荐"
      }
    ],
    field: "institutionSource",
    require: false
  },
  {
    label: "办公省份",
    formtype: "",
    field: "officeAddress", //这里要改为对应字段！！
    require: false,
    rules: [{ max: 255, message: "不能超过255位", trigger: "blur" }]
  },
  // {
  //   label: "协会登记编号",
  //   formtype: "",
  //   field: "associationNo",
  //   require: false
  // },
  // {
  //     label: "注册三个月内拟实缴出资额(万元)", //该字段应注释
  //     formtype: "",
  //     inputType: "number",
  //     field: "registedM3Paid",
  //     require: false
  // },
  // {
  //     label: '已管理（拟发行）基金规模(万元)', //该字段应注释
  //     field: 'fundMgrScale',
  //     inputType: "number",
  //     formtype: "",
  //     require: false
  // },
  // {
  //     label: "展业计划",//该字段应注释
  //     formtype: "upload",
  //     field: "uploadField",
  //     require: false
  // },
  {
    label: "小镇经办人员",
    formtype: "",
    field: "inviteCode",
    // disabled: true,
    require: false,
    rules: [{ max: 255, message: "输入不能超过255位", trigger: "blur" }]
  }
];

export const newStep2 = [
  {
    label: "企业名称(全称)",
    formtype: "",
    field: "institutionName",
    // disabled: true,
    rules: [
      { required: false, message: "请输入企业名称", trigger: "blur" },
      { max: 100, message: "输入不能超过100位", trigger: "blur" }
    ],
    require: true
  },
  {
    label: "注册资本（万元）",
    formtype: "",
    field: "capitalRegisted",
    // disabled: true,
    error: "请输入正确的注册资本（万元）",
    require: true,
    rules: [
      { required: false, message: "请输入注册资本", trigger: "blur" },
      { max: 16, message: "不能超过16位", trigger: "blur" }
    ]
  },
  {
    label: "统一社会信用代码（组织机构代码）",
    formtype: "",
    field: "associationNo",
    // disabled: true,
    require: false,
    rules: [
      { required: false, message: "统一社会信用代码", trigger: "blur" },
      { max: 18, message: "请输入正确的统一社会信用代码（组织机构代码）", trigger: "blur" }
    ]
  },
  {
    label: "实收资本（万元）",
    formtype: "",
    field: "capitalPaid",
    // disabled: true,
    require: true,
    rules: [
      { required: false, message: "实收资本", trigger: "blur" },
      { max: 16, message: "输入不能超过16位", trigger: "blur" }
    ]
  },
  // ,{
  //     label: "成立日期",
  //     formtype: "",
  //     field: "createdTime",
  //     disabled: true,
  //     require: true
  // }
  {
    label: "管理人类型",
    formtype: "select",
    options: [
      {
        label: "股权、创业类",
        value: "股权、创业类"
      },
      {
        label: "证券类",
        value: "证券类"
      },
      {
        label: "其他",
        value: "其他"
      }
    ],
    field: "fundType",
    require: false
  },
  {
    label: "管理基金数量",
    formtype: "",
    field: "fundMgrScale",
    require: false
  },
  {
    label: "是否需要中国证券投资基金业协会登记/备案",
    formtype: "select",
    options: [
      {
        label: "是",
        value: "1"
      },
      {
        label: "否",
        value: "0"
      }
    ],
    field: "associationRegiste",
    require: false
  },
  {
    label: "管理基金认缴出资总额(万元)",
    formtype: "",
    field: "mgrFundCapitalAdmit",
    require: false
  },
  // , {
  //     label: "是否完成中国证券投资基金业协会登记/备案",
  //     formtype: "select",
  //     options: [{
  //             label: "是",
  //             value: 1
  //         },
  //         {
  //             label: "否",
  //             value: 0
  //         }
  //     ],
  //     field: "associationRegisteFinished",
  //     require: false
  // }
  {
    label: "管理基金实缴出资总额(万元)",
    formtype: "",
    field: "mgrFundCapitalPaid",
    require: false,
    rules: [
      { required: false, message: "管理基金实缴出资总额", trigger: "blur" },
      { max: 16, message: "不能超过16位", trigger: "blur" }
    ]
  },
  {
    label: "中基协登记时间",
    formtype: "date",
    field: "registeTime",
    require: false
  },
  {
    label: "拟投行业",
    formtype: "select",
    selectType: true,
    options: [
      {
        label: "高端智能制造",
        value: "高端智能制造"
      },
      {
        label: "移动互联网",
        value: "移动互联网"
      },
      {
        label: "新材料",
        value: "新材料"
      },
      {
        label: "生物医药和健康",
        value: "生物医药和健康"
      },
      {
        label: "文化创新",
        value: "文化创新"
      },
      {
        label: "新能源和环保",
        value: "新能源和环保"
      },
      {
        label: "军民融合",
        value: "军民融合"
      },
      {
        label: "现代服务",
        value: "现代服务"
      },
      {
        label: "食品和家电",
        value: "食品和家电"
      },
      {
        label: "其他",
        value: "其他"
      }
    ],
    field: "preIndustry",
    require: false
  },
  {
    label: "主发起人省份",
    formtype: "select",
    options: [],
    field: "initiatorDistrict",
    require: false
  },
  {
    label: "职工人数",
    formtype: "",
    field: "staffCount",
    require: false
  },
  {
    label: "是否集群注册",
    formtype: "select",
    options: [
      {
        label: "是",
        value: 1
      },
      {
        label: "否",
        value: 0
      }
    ],
    field: "clusterRegiste",
    require: false
  },
  {
    //     label: '工位注册托管期限',
    //     formtype: "date",
    //     field: "registeExpireDate",
    //
    // }, {
    label: "从业人员数",
    formtype: "",
    field: "employeeCount",
    require: false,
    rules: [
      { required: false, message: "从业人员数", trigger: "blur" },
      { max: 255, message: "不能超过255位", trigger: "blur" }
    ]
  },
  {
    label: "注册地址",
    formtype: "",
    field: "registeAddress",
    require: false,
    rules: [
      { required: false, message: "注册地址", trigger: "blur" },
      { max: 255, message: "不能超过255位", trigger: "blur" }
    ]
  },
  {
    label: "机构来源",
    formtype: "select",
    options: [
      {
        label: "已入驻客户新设机构",
        value: "已入驻客户新设机构"
      },
      {
        label: "慕名而来",
        value: "慕名而来"
      },

      {
        label: "他人推荐",
        value: "他人推荐"
      }
    ],
    field: "institutionSource",
    require: false
  },
  {
    label: "办公省份",
    formtype: "",
    field: "officeAddress", //这里要改为对应字段！！
    require: false,
    rules: [
      { required: false, message: "办公省份", trigger: "blur" },
      { max: 255, message: "不能超过255位", trigger: "blur" }
    ]
  },
  // {
  //   label: "协会登记编号",
  //   formtype: "",
  //   field: "associationNo",
  //   require: false
  // },
  // {
  //     label: "注册三个月内拟实缴出资额(万元)", //该字段应注释
  //     formtype: "",
  //     inputType: "number",
  //     field: "registedM3Paid",
  //     require: false
  // },
  // {
  //     label: '已管理（拟发行）基金规模(万元)', //该字段应注释
  //     field: 'fundMgrScale',
  //     inputType: "number",
  //     formtype: "",
  //     require: false
  // },
  // {
  //     label: "展业计划",//该字段应注释
  //     formtype: "upload",
  //     field: "uploadField",
  //     require: false
  // },
  {
    label: "小镇经办人员",
    formtype: "",
    field: "inviteCode",
    // disabled: true,
    require: false,
    rules: [
      { required: false, message: "小镇经办人员", trigger: "blur" },
      { max: 255, message: "输入不能超过255位", trigger: "blur" }
    ]
  }
];

//step2
export const step2 = [
  {
    label: "出资人名称",
    field: "investorName",
    formtype: "",
    require: true,
    rules: [
      {
        required: false,
        message: "出资人名称",
        trigger: "blur"
      },
      { max: 255, message: "输入不能超过255位", trigger: "blur" }
    ]
  },
  {
    label: "出资人性质",
    field: "investorCharacter",
    formtype: "select",
    options: [],
    require: true,
    rules: [
      { required: false, message: "出资人性质", trigger: "blur" },
      { max: 255, message: "输入不能超过255位", trigger: "blur" }
    ]
  },
  {
    label: "身份证号码/统一社会信用代码",
    field: "investorNo",
    formtype: "",
    require: false,
    rules: [
      { required: false, message: "身份证号码/统一社会信用代码", trigger: "blur" },
      { max: 18, message: "请输入正确的身份证号码/统一社会信用代码", trigger: "blur" }
    ]
  },
  {
    label: "认缴出资额(万元)",
    field: "capture",
    inputType: "number",
    formtype: "",
    require: true,
    rules: [
      { required: false, message: "认缴出资额", trigger: "blur" },
      { max: 16, message: "输入不能超过16位", trigger: "blur" }
    ]
  },
  {
    label: "认缴出资比例(%)",
    field: "capturePercent",
    inputType: "number",
    formtype: "",
    require: false,
    disabled: true,
    rules: [
      { required: false, message: "小镇经办人员", trigger: "blur" },
      { max: 16, message: "输入不能超过16位", trigger: "blur" }
    ]
  },
  {
    label: "出资人类别",
    formtype: "select",
    field: "investorType",
    options: [
      {
        label: "普通合伙人",
        value: "普通合伙人"
      },
      {
        label: "有限合伙人",
        value: "有限合伙人"
      },

      {
        label: "其他",
        value: "其他"
      }
    ],
    require: true
  },
  {
    label: "是否符合合格投资者条件",
    formtype: "select",
    field: "qualified",
    options: [
      {
        label: "是",
        value: "1"
      },
      {
        label: "否",
        value: "0"
      }
    ],
    require: false
  }
  // {
  //     label: '简介',
  //     field: 'abstractInfo',
  //     formtype: "",
  //     inputType: "textarea",
  //     autosize: { minRows: 5, maxRows: 10 },
  //     class: "infoLine",
  //
  // }
];

// //step2-dialog
// export const step2Dialog = [{
//   label: '出资人名称',
//   field: 'name',
//   type: "",
//
// }, {
//   label: '性质',
//   field: 'type',
//   type: "select",
//   options: [
//     {
//       label: "是",
//       value: "是"
//     },
//     {
//       label: "否",
//       value: "否"
//     }
//   ],
//
// }, {
//   label: '证件号码',
//   field: 'number',
//   type: "",
//
// }, {
//   label: '认缴出资额(万元)',
//   field: 'count',
//   type: "",
//
// }, {
//   label: '认缴出资比例(%)',
//   field: 'percent',
//   type: "",
//
// }, {
//   label: '注册三个月内拟实缴出资额(万元)',
//   field: 'count2',
//   type: "",
//
// }, {
//   label: '简介',
//   field: 'count3',
//   type: "",
//
// }, {
//   label: '联系电话',
//   field: 'phone'
// }];

//step3
export const step3 = [
  [
    {
      label: "姓名",
      field: "personName",
      formtype: "",
      rules: [
        { required: true, message: "请输入姓名", trigger: "blur" },
        { validator: validateName, trigger: "blur" }
      ]
    },
    {
      label: "联系方式",
      field: "tel",
      formtype: "",
      rules: [
        { required: true, message: "请输入联系方式", trigger: "blur" },
        { validator: validatePhone, trigger: "blur" }
      ]
    },
    {
      label: "邮箱",
      field: "email",
      formtype: "",
      rules: [
        { required: true, message: "请输入正确的邮箱", trigger: "blur" },
        { validator: validateEMail, trigger: "blur" }
      ]
    }
    // {
    //   label: '身份证/营业执照',
    //   field: 'identityFileOrignName',
    //   formtype: "",
    //
    // }
  ],
  // step3-2
  [
    {
      label: "姓名",
      field: "personName",
      formtype: "",

      rules: [
        { required: true, message: "请输入姓名", trigger: "blur" },
        { validator: validateName, trigger: "blur" }
      ]
    },
    {
      label: "职务",
      field: "personType",
      formtype: "select",
      options: [
        {
          label: "法定代表人/执行事务合伙人（委派代表）",
          value: 2
        },
        {
          label: "投资经理",
          value: 3
        },
        {
          label: "合规风控负责人",
          value: 4
        }
      ],

      rules: [{ required: true, message: "请选择人员类型", trigger: "blur" }]
    },
    {
      label: "身份证号码",
      field: "certificateNo",
      formtype: "",

      rules: [
        { required: true, message: "请输入身份证号码", trigger: "blur" },
        { validator: validateIdNo, trigger: "blur" }
      ]
    },
    {
      label: "联系电话",
      field: "tel",
      formtype: "",

      rules: [
        { required: true, message: "请输入联系方式", trigger: "blur" },
        {
          max: 11,
          message: "请输入正确的电话号码",
          trigger: "blur"
        },
        { validator: validatePhone, trigger: "blur" }
      ]
    },
    {
      label: "最高学历",
      field: "degree",
      formtype: "select",
      options: [],

      rules: [{ required: true, message: "请输入最高学历", trigger: "change" }]
    },
    {
      label: "是否具备基金从业资格",
      field: "qualification",
      formtype: "select",
      options: [
        {
          label: "是",
          value: "1"
        },
        {
          label: "否",
          value: "0"
        }
      ],

      rules: [{ required: true, message: "请输入是否具备基金从业资格", trigger: "change" }]
    }
  ],
  //step3-3
  [
    {
      label: "姓名/机构名",
      field: "personName",
      formtype: "",
      rules: [{ required: true, message: "请输入姓名", trigger: "blur" }]
    },
    {
      label: "身份证号码/\n统一社会信用代码",
      field: "certificateNo",
      formtype: "",
      rules: [{ required: true, message: "请输入身份证号码", trigger: "blur" }]
    },
    {
      label: "联系方式",
      field: "tel",
      formtype: "",
      rules: [
        { required: true, message: "请输入联系方式", trigger: "blur" },
        { validator: validatePhone, trigger: "blur" }
      ]
    }
    // {
    //   label: '身份证/营业执照',
    //   field: 'identityFileOrignName',
    //   formtype: "",
    //
    // }
  ],
  //step3-4
  [
    {
      label: "姓名",
      field: "personName",
      formtype: "",

      rules: [
        {
          required: true,
          message: "请输入姓名",
          trigger: "blur"
        },
        { validator: validateName, trigger: "blur" }
      ]
    },

    {
      label: "身份证号码",
      field: "certificateNo",
      formtype: "",

      rules: [
        { required: true, message: "请输入身份证号码", trigger: "blur" },
        { validator: validateIdNo, trigger: "blur" }
      ]
    },
    {
      label: "邮箱",
      field: "email",
      formtype: "",
      rules: [
        { required: true, message: "请输入正确的邮箱", trigger: "blur" },
        { validator: validateEMail, trigger: "blur" }
      ]
    },
    {
      label: "联系电话",
      field: "tel",
      formtype: "",

      rules: [
        { required: true, message: "请输入联系方式", trigger: "blur" },
        { validator: validatePhone, trigger: "blur" }
      ]
    }
  ]
];

// //step3-添加联系人、财务负责人
// export const contactDialog = [{
//   label: '姓名',
//   field: 'name',
//   type: "",
//
// }, {
//   label: '身份证号',
//   field: 'number',
//   type: "",
//
// }, {
//   label: '联系方式',
//   field: 'phone',
//   type: "",
//
// }, {
//   label: '邮箱',
//   field: 'email',
//   type: "",
//
// }];

// //step3-添加法定代表人
// export const legalDialog = [{
//   label: '姓名',
//   field: 'name',
//   type: "",
//
// }, {
//   label: '性别',
//   field: 'sex',
//   type: "select",
//   options: [
//     {
//       label: "男",
//       value: "男"
//     },
//     {
//       label: "女",
//       value: "女"
//     }
//   ],
//
// }, {
//   label: '民族',
//   field: 'country',
//   type: "select",
//   options: [
//     {
//       label: "男",
//       value: "男"
//     },
//     {
//       label: "女",
//       value: "女"
//     }
//   ],
//
// }, {
//   label: '证件类型',
//   field: 'type',
//   type: "select",
//   options: [
//     {
//       label: "男",
//       value: "男"
//     },
//     {
//       label: "女",
//       value: "女"
//     }
//   ],
//
// }, {
//   label: '证件号码',
//   field: 'number',
//   type: "",
//
// }, {
//   label: '联系电话',
//   field: 'phone',
//   type: "",
//
// }, {
//   label: '邮箱',
//   field: 'email',
//   type: "",
//
// }, {
//   label: '出生日期',
//   field: 'birthday',
//   type: "",
//
// }, {
//   label: '最高学历',
//   field: 'school',
//   type: "select",
//   options: [
//     {
//       label: "本科",
//       value: "本科"
//     },
//     {
//       label: "专科",
//       value: "专科"
//     }
//   ],
//
// }, {
//   label: '是否具备基金从业资格',
//   field: 'isper',
//   type: "",
//
// }, {
//   label: '项目投资经验和业绩',
//   field: 'add1',
//   type: "",
//
// }, {
//   label: '学历经历',
//   field: 'add2',
//   type: "",
//
// }, {
//   label: '工作经历',
//   field: 'add3',
//   type: "",
//
// }];

//step4
export const step4 = [
  [
    {
      label: "公司章程",
      tabletype: "anyDo", //未知操作，通过emit向外触发
      typeField: "上传/upload" // 名字/类型
    },
    {
      label: "核名通知书",
      tabletype: "anyDo", //未知操作，通过emit向外触发
      typeField: "上传/upload" // 名字/类型
    }
  ],
  [
    {
      label: "其他资料",
      tabletype: "anyDo", //未知操作，通过emit向外触发
      typeField: "上传/upload" // 名字/类型
    }
  ]
];

export const list = [
  {
    label: "企业名称(全称)",
    field: "institutionName",
    formtype: "",
    require: false,
    disabled: true
  },
  {
    label: "申请时间",
    field: "commitTime",
    formtype: "",
    require: false
  },
  {
    label: "申请状态",
    field: "checkState",
    tabletype: "listTags",
    require: false
  },
  {
    label: "审核意见",
    field: "checkFeedback",
    formtype: "",
    require: false
  }
];

export const uploadConfig = [
  [
    {
      label: "公司章程",
      field: "regulationOrignName",
      formtype: "",
      require: false
    },
    {
      label: "核名通知书",
      field: "checkNoticeOrignName",
      formtype: "",
      require: false
    }
  ],
  [
    {
      label: "实际办公地址",
      field: "office", //拼接组成地址
      formtype: "",
      require: false
    },
    {
      label: "具体办公地址",
      field: "realOfficeAddress",
      formtype: "",
      require: false
    },
    {
      label: "办公面积(平方米)",
      field: "officeArea",
      formtype: "",
      require: false,
      rules: [
        { required: false, message: "办公面积", trigger: "blur" },
        { message: "请输入请输入一个正数", trigger: "blur" }
      ]
    },
    {
      label: "材料名称",
      field: "officRentOrignName",
      formtype: "",
      require: false
    }
  ],
  [
    {
      label: "其他资料",
      field: "otherFileOrignName", //拼接组成地址
      formtype: "",
      require: false
    }
  ]
];

export const step4Company = [
  {
    label: "材料名称",
    field: "name",
    formtype: "",
    require: false
  },
  {
    label: "附件名称",
    field: "oldFile",
    formtype: "",
    require: false
  }
];

export const step4Other = [
  {
    label: "材料名称",
    field: "name",
    formtype: "",
    require: false
  },
  {
    label: "附件名称",
    field: "oldFile",
    formtype: "",
    require: false
  }
];
